import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "@/components/ToastNotification";
import { api } from "@/lib/api";
import { useEffect, useState } from "react";
import { ExameEditProps } from "./interfaces/Exame.interface";
// import { ModeloFormulario } from "./interfaces/Exame.interface";
// import { Checkbox } from "@/components/ui/checkbox";

const ExameEdit = ({ open, onOpenChange, exame, onSuccess }: ExameEditProps) => {

  const [formData, setFormData] = useState({
    nome: "",
    descricao: "",
    ativo: true
  });

  // const [modelosFormularios, setModelosFormularios] = useState<ModeloFormulario[]>([]);
  const [loading, setLoading] = useState(false);
  // const [loadingModelos, setLoadingModelos] = useState(false);

  // useEffect(() => {
  //   if (open) {
  //     fetchModelosFormularios();
  //   }
  // }, [open]);

  useEffect(() => {
    if (exame) {
      setFormData({
        nome: exame.nome || "",
        descricao: exame.descricao || "",
        ativo: exame.ativo ?? true
      });
    } else {
      setFormData({
        nome: "",
        descricao: "",
        ativo: true
      });
    }
  }, [exame, open]);

  // const fetchModelosFormularios = async () => {
  //   try {
  //     setLoadingModelos(true);
  //     const response: { result: ModeloFormulario[] } = await api.get("/api/modelos-formularios");
  //     setModelosFormularios(response.result || []);
  //   } catch (error) {
  //     console.error("Erro ao carregar modelos de formulários:", error);
  //     toast({
  //       title: "Erro",
  //       description: "Não foi possível carregar os modelos de formulários",
  //       variant: "destructive",
  //     });
  //   } finally {
  //     setLoadingModelos(false);
  //   }
  // };

  // Função para obter id_empresa do usuário autenticado
  const getIdEmpresa = (): number | null => {
    try {
      const userStr = localStorage.getItem('auth_user');
      if (userStr) {
        const user = JSON.parse(userStr);
        return user.id_empresa || null;
      }
    } catch (error) {
      console.error('Erro ao obter id_empresa:', error);
    }
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const idEmpresa = getIdEmpresa();
      
      const payload = {
        nome: formData.nome,
        descricao: formData.descricao || '',
        ativo: formData.ativo,
        id_empresa: 1
      };

      // Se tiver ID, fazer PUT (atualizar), senão fazer POST (criar)
      if (exame?.id) {
        await api.put(`/api/exames/${exame.id}`, payload);
        toast.success("Exame atualizado com sucesso!");
      } else {
        await api.post("/api/exames", payload);
        toast.success("Exame criado com sucesso!");
      }

      onSuccess();
      onOpenChange(false);
    } catch (error: any) {
      console.error("Erro ao salvar exame:", error);
      toast.error(error?.message || "Erro ao salvar o exame");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => onOpenChange(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{exame ? "Editar Exame" : "Novo Exame"}</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Nome */}
          <div className="space-y-2">
            <Label htmlFor="nome">Nome *</Label>
            <Input
              id="nome"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              placeholder="Ex: Ultrassom Ocular"
              maxLength={150}
              required
            />
            <p className="text-xs text-muted-foreground">
              Nome do exame (máximo 150 caracteres)
            </p>
          </div>

          {/* Descrição */}
          <div className="space-y-2">
            <Label htmlFor="descricao">Descrição</Label>
            <Textarea
              id="descricao"
              value={formData.descricao}
              onChange={(e) => setFormData({ ...formData, descricao: e.target.value })}
              placeholder="Descrição detalhada do exame"
              rows={4}
            />
            <p className="text-xs text-muted-foreground">
              Descrição opcional do exame
            </p>
          </div>

          {/* Modelos de Formulários */}
          {/* <div className="space-y-2">
            <Label>Modelos de Formulários</Label>
            {loadingModelos ? (
              <p className="text-sm text-muted-foreground">Carregando modelos...</p>
            ) : modelosFormularios.length === 0 ? (
              <p className="text-sm text-muted-foreground">
                Nenhum modelo de formulário disponível
              </p>
            ) : (
              <div className="border rounded-md p-4 max-h-60 overflow-y-auto space-y-2">
                {modelosFormularios.map((modelo) => (
                  <div key={modelo.id} className="flex items-center space-x-2">
                    <Checkbox
                      id={`modelo-${modelo.id}`}
                      checked={formData.modelosFormulariosIds.includes(modelo.id)}
                      onCheckedChange={(checked) =>
                        handleModeloChange(modelo.id, checked === true)
                      }
                    />
                    <Label
                      htmlFor={`modelo-${modelo.id}`}
                      className="text-sm font-normal cursor-pointer"
                    >
                      {modelo.nome}
                      {modelo.descricao && (
                        <span className="text-muted-foreground ml-2">
                          - {modelo.descricao}
                        </span>
                      )}
                    </Label>
                  </div>
                ))}
              </div>
            )}
            <p className="text-xs text-muted-foreground">
              Selecione os modelos de formulários associados a este exame
            </p>
          </div> */}

          {/* Status */}
          <div className="flex items-center space-x-2">
            <Switch
              id="ativo"
              checked={formData.ativo}
              onCheckedChange={(checked) => setFormData({ ...formData, ativo: checked })}
            />
            <Label htmlFor="ativo">Exame ativo</Label>
          </div>

          <div className="flex justify-end gap-2 pt-4">
            <Button type="button" variant="outline" onClick={handleClose} disabled={loading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Salvando..." : exame ? "Atualizar" : "Criar"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ExameEdit;
